import React from 'react';
import { XpIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst, onTrackYandexGoal } from 'modules/global';

export const ViewCorrectAnswer: React.FC = () => {
  const t = useTranslations();

  return (
    <div className="relative flex items-center justify-between rounded-xl bg-green-200">
      <div className="p-4 pb-5">
        <div className="mb-1 flex items-center gap-2">
          <XpIcon fill={globalConst.colors.green[900]} />
          <span className="text-sm font-bold text-green-900 sm:text-base">{t('togri_javobni_korsatish')}</span>
        </div>
        <p className="mb-0 text-xs font-medium leading-normal text-green-800 sm:mb-4">
          {t('siz_xato_javob_berdingiz_togri_javob_va_sababini_korish_uchun_pro_sotib_oling')}
        </p>
        <Link
          href={globalConst.pageNames.PRO}
          target="_blank"
          onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.wrong_answer)}
          className="hidden w-max rounded-xl bg-green-500 px-4 py-2.5 text-sm text-white sm:block"
        >
          {t('obuna_bolish')}
        </Link>
      </div>
      <div className="sm:size-30 min-w-18 relative size-20">
        <Image fill alt="view correct answer" src="/images/view-correct-answer.webp" />
      </div>
    </div>
  );
};
